enum Client {
  UNKNOWN = 'UNKNOWN',
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
  ELECTRON = 'ELECTRON'
}

export default Client
